import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { ConfigServerService, CustomHttp } from '../../../../../core';
import { IntegrationItem } from '../integration-item';

@Injectable({
    providedIn: 'root'
})
export class IntegrationItemHttpService {
    private pathApi: string;

    constructor(private customHttp: CustomHttp,
                configServerService: ConfigServerService) {
        this.pathApi = `${configServerService.getPathApiIntegration()}/item`;
    }

    /** Executa as integrações de leituras dos itens nos sistemas ERP's manualmente */
    execReadIntegrationManual(entity: IntegrationItem): Observable<string> {
        // Params
        let params = new HttpParams();
        if (entity) {
            params = entity.createParams(params);
        }

        return this.customHttp.post<string>(`${this.pathApi}/manual`, null, {params, responseType: 'text'});
    }

    /** Executa a integração de leitura individual dos dados do item informado no ERP */
    execReadIndividualIntegration(id: number): Observable<string> {
        return this.customHttp.post<string>(`${this.pathApi}/individual/${id}`, null, {responseType: 'text'});
    }
}
